(function($) { 


	/* ================ owlCarousel ================ */
	
  	$(".leftcate").click(function(){
    	$(".categoryWrp").toggle();
	});
  
  
  	$(".featured-products").owlCarousel({ 
      
	   loop:true,
		margin:14,
		nav:false,
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
				nav:true
			},
			600:{
				items:1,
				nav:false
			},
			990:{
				items:1,
				nav:false
			},
			1300:{
				items:1,
				nav:true,
				loop:false
			}
		}
	  
	  
 
	});	
	
	$(".related-products").owlCarousel({ 
      
	   loop:true,
		margin:14,
		nav:false,
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
				nav:true
			},
			600:{
				items:2,
				nav:false
			},
			990:{
				items:3,
				nav:false
			},
			1024:{
				items:3,
				nav:true,
				loop:false
			},
			1300:{
				items:4,
				nav:true,
				loop:false
			}
		}
	  
	  
 
	});
	
	$(".owl-carousel").owlCarousel({ 
      
	   loop:true,
		margin:14,
		nav:false,
		responsiveClass:true,
		responsive:{
			0:{
				items:1,
				nav:true
			},
			600:{
				items:2,
				nav:false
			},
			990:{
				items:3,
				nav:false
			},
			1024:{
				items:5,
				nav:true,
				loop:false
			},
			1300:{
				items:6,
				nav:true,
				loop:false
			}
		}
	  
	  
 
	});	
	
	
	
	
	
	
	
	

	
	
	
	
})(jQuery);